// Poll configuration constants

export const POLL_SCOPES = {
  national: {
    key: 'national',
    icon: '🗺️',
    label: 'National',
    description: 'Poll the entire nation for aggregate standings',
    baseCost: 1,
  },
  regional: {
    key: 'regional',
    icon: '🏛️',
    label: 'Regional',
    description: 'Poll a specific region for local insights',
    baseCost: 1,
  },
  district: {
    key: 'district',
    icon: '📍',
    label: 'District',
    description: 'Poll a single district for granular data',
    baseCost: 1,
  },
} as const

export const POLL_DETAIL_LEVELS = {
  basic: {
    key: 'basic',
    label: 'Basic',
    description: 'Party standings with standard margin of error',
    additionalCost: 0,
    marginOfError: [5, 8] as const, // ±5-8%
    includesCohortBreakdown: false,
    includesTopIssues: false,
  },
  detailed: {
    key: 'detailed',
    label: 'Detailed',
    description: 'Smaller margin of error, cohort breakdown, top issues',
    additionalCost: 1,
    marginOfError: [2, 4] as const, // ±2-4%
    includesCohortBreakdown: true,
    includesTopIssues: true,
  },
} as const

export type PollScope = keyof typeof POLL_SCOPES
export type PollDetailLevel = keyof typeof POLL_DETAIL_LEVELS

export const POLL_SCOPE_ORDER: PollScope[] = ['national', 'regional', 'district']

// What you'll learn based on detail level
export const POLL_INSIGHTS = {
  basic: [
    'Party vote share estimates',
    'Margin of error: ±5-8%',
  ],
  detailed: [
    'Party vote share estimates',
    'Margin of error: ±2-4%',
    'Which cohorts favor each party',
    'Top 3 issues driving preferences',
  ],
} as const
